import * as React from "react";
import MobileContainer from "../../Containers/MobileContainer";
import TelecelFooterLogo from "../../SVG/mobile/telecel_footer_logo";
import AccordionMenu from "../../layout/Common/menuToggleComponent";
import { navigate } from "gatsby";
import { CaretUp, CaretDown } from "@phosphor-icons/react";

const MobileFooter = ({ footerData }) => {

  const [activeIndex, setActiveIndex] = React.useState(null);
  const [secondLevelMenus, setSecondLevelMenus] = React.useState(footerData);

  const handleMenuClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <footer className="block md:hidden bg-black mt-17">
      <MobileContainer className="w-full h-full">
        <div className="w-full h-35 flex items-center">
          <div
            className="cursor-pointer"
            onClick={() => {
              // navigate("/");
            }}
          >
            <TelecelFooterLogo />
          </div>
        </div>
      </MobileContainer>
      <div className="w-full">
        <div className="text-white border-y border-gray_700">
     
          <div className="py-5">
          {secondLevelMenus.map((item, index) => {
                  const { id, title, children } = item;
                  return (
                    <div key={index}>
                      <AccordionMenu
                        key={id + title}
                        label={title}
                        onRowClicked={() => {
                          handleMenuClick(index);
                        }}
                        hasIcon={children.length > 0}
                        Icon={
                          activeIndex === index ? <CaretUp /> : <CaretDown />
                        }
                        wrapperStyles={"h-15"}
                        labelStyles={
                          "text-body_base font-semibold text-white"
                        }
                      />

                      {activeIndex === index && (
                        <>
                          {children.map((item, index) => {
                            const { id, title, children, link } = item;
                            return (
                              <AccordionMenu
                              link={link}
                                key={id + title}
                                label={title}
                                onRowClicked={() => {
                                    navigate(link)
                                }}
                                // hasIcon={children.length > 0}
                                // Icon={<CaretUp />}
                                wrapperStyles={"py-5 px-10"}
                                labelStyles={
                                  "text-body_sm text-white font-semibold text-gray_800 cursor-pointer"
                                }
                              />
                            );
                          })}
                        </>
                      )}
                    </div>
                  );
                })}
          </div>

         
        </div>
      </div>
    </footer>
  );
};

export default MobileFooter;
